import { render } from "./RecommendedBlog.vue?vue&type=template&id=e5062b56&scoped=true"
import script from "./RecommendedBlog.vue?vue&type=script&lang=js"
export * from "./RecommendedBlog.vue?vue&type=script&lang=js"

import "./RecommendedBlog.vue?vue&type=style&index=0&id=e5062b56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5062b56"]])

export default __exports__